var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { createWidget } from 'app/store/reducers/widgets';
import { omitBy, isNil } from 'lodash';
import FormData from 'app/components/Form/FormData/FormData.jsx';
import { ModalConfirmForm } from 'app/components/Modal';
import { WIDGET_TYPES } from 'app/pages/Project/ProductionManagement/Dashboards/constants';
import formFields from 'app/pages/Project/Settings/Dashboards/ModalCreateWidgetGroup/formFileds';
import { getResources } from 'app/store/selectors/getResources';
const ModalCreateWidgetGroup = (_a) => {
    var _b;
    var { dashboardId, parent, widgets } = _a, modalprops = __rest(_a, ["dashboardId", "parent", "widgets"]);
    const dispatch = useDispatch();
    const stepProjects = getResources(undefined, 'steps');
    const defaultIsSupervisor = (_b = parent === null || parent === void 0 ? void 0 : parent.rel_dashboardWidgetInst.isSupervisor) !== null && _b !== void 0 ? _b : false;
    const fields = formFields({ defaultIsSupervisor, stepProjects });
    const handleCreateWidgetGroup = (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { name, steps, isSupervisor, assetType } = data;
        const stepsIds = steps === null || steps === void 0 ? void 0 : steps.map((step) => step.value);
        const config = {
            assetType,
            steps: stepsIds,
        };
        const widgetGroup = {
            config: omitBy(config, isNil),
            parent: (_a = parent === null || parent === void 0 ? void 0 : parent.id) !== null && _a !== void 0 ? _a : null,
            name,
            widgetType: WIDGET_TYPES.CONTAINER,
        };
        const res = yield dispatch(createWidget({
            widget: widgetGroup,
            dashboardId,
            isSupervisor,
        }));
        return res;
    });
    return (_jsx(ModalConfirmForm, Object.assign({ draggable: false, title: "Create widget group", validateLabel: "Save" }, modalprops, { children: _jsx(FormData, { onSave: (data) => __awaiter(void 0, void 0, void 0, function* () {
                const res = yield handleCreateWidgetGroup(data);
                return res;
            }), defaultData: {}, properties: fields, flashNotifSuccessLabel: "Widget group created" }) })));
};
export default ModalCreateWidgetGroup;
